<!-- 顶部菜单 -->
<template>
  <div class="top-menu">
    <el-menu :default-active="activeIndex"  class="el-menu-demo" mode="horizontal">
      <template v-for="item in menuList" :key="item.path">
        <!-- 无子菜单的项 -->
        <el-menu-item v-if="!item.children?.length" :index="item.path" @click="handleMenuClick(item)">{{ item.meta?.title }}</el-menu-item>
        <!-- 有子菜单的项 -->
        <el-sub-menu v-else :index="item.path">
          <template #title>
            {{ item.meta?.title }}
          </template>
          <el-menu-item v-for="child in item.children" :key="child.path" :index="child.path" @click="handleMenuClick(child)">
            {{ child.meta?.title }}
          </el-menu-item>
        </el-sub-menu>
      </template>
    </el-menu>
  </div>
  <!-- 系统名称弹窗 -->
  <SystemNameDialog v-model:visible="dialogVisible"/>
</template>

<script setup>
import {ref} from 'vue'
import {useRouter} from 'vue-router'
import system from '@/router/modules/system'
import SystemNameDialog from '@/views/system/logoAndName/index.vue'
const router = useRouter()
const dialogVisible = ref(false)
const activeIndex=ref("/user")
let menuList = system.filter((item) => Boolean(item.hideMenu) === false)
// 处理菜单点击
const handleMenuClick = (menuItem) => {
  if (menuItem.meta?.isAction) {
    // 处理操作项（弹窗）
    dialogVisible.value = true
  } else {
    const { redirect, path } = menuItem
    if (redirect) {
      router.push(redirect.toString())
      return
    }
    router.push(path)
  }
}
</script>
<style>
.el-popper.is-light{
  outline: none !important;
  border: none !important;
}
.el-popper:focus,
.el-popper:hover,
.el-popper:focus-visible {
  outline: none !important;
  border: none !important;
}
.el-menu--horizontal:focus,
.el-menu--horizontal:hover,
.el-menu--horizontal:focus-visible {
  outline: none !important;
  border: none !important;
}

.el-menu:focus,
.el-menu:hover,
.el-menu:focus-visible {
  outline: none !important;
  border: none !important;
}
</style>
<style lang="scss" scoped>
.top-menu {
  width: 70%;
  height: 50px;
  .el-menu-demo{
    border: none;
  }
  :deep(.el-menu--horizontal){
    height: 50px;
    display: flex;
    align-items: center;
  }
  :deep(.el-sub-menu){
     height: 50px;
  }
  :deep(.el-menu--horizontal.el-menu){
    background-color: transparent;
    border: none !important;
  }
  :deep(.el-menu--horizontal>.el-sub-menu .el-sub-menu__title){
    color: #ffffff;
    font-size: 16px;
    border-bottom: 0;
  }
  :deep(.el-menu--horizontal>.el-sub-menu .el-sub-menu__title:hover){
    background-color: transparent;
  }
  :deep(.is-active){
    background-color: #fff;
    height: 35px;
    border-radius: 5px;
    .el-sub-menu__title{
      color: #000 !important;
    }
  }
}

</style>
